/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Vue from 'vue';
import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_SELF_GOODS_CATES_SUCCESS,
    GET_SELF_GOODS_CATES_REQUEST,
    GET_SELF_GOODS_CATES_FAILURE,
    CLEAR_SELF_GOODS_CATES,
    GET_SELF_GOODS_LIST_REQUEST,
    GET_SELF_GOODS_LIST_SUCCESS,
    GET_SELF_GOODS_LIST_FAILURE,
    UPDATE_SELF_GOODS_LIST,
    UPDATE_SELF_GOODS_LIST_PARAMS,
    RESET_SELF_GOODS_LIST,
    RESOLVE_SELF_GOODS_LIST_PARAMS,
    UPDATE_WAIT_DATA
} from '../mutationTypes';

const state = {
    loading: false,
    inventoryStatus: 1, // 库存状态（1 = 全部， 2 = 库存充足， 3 = 库存预警）
    page: 1,
    pagesize: 20,
    goodsName: '', // 商品名称
    goodsBrand: '', // 商品品牌
    isLoss: 1, // 是否损耗件（1 = 全部， 2 = 是， 3 = 否）
    goodsStatus: 1, // 商品状态
    barCode: '', // 条形码
    cateLoading: true, // 商品分类loading
    tmp: 1,
    cate1_id: '',
    cate2_id: '',
    cate3_id: '',
    cateL1: [],
    cateL2: [],
    cateL3: [],
    listData: [],
    pageCount: 1,
    reqParams: {},
    noData: false
};

const mutations = {
    [GET_SELF_GOODS_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_SELF_GOODS_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = Number(res.page_count);
        state.listData = res.data;
        state.noData = res.data.length === 0;
    },
    [GET_SELF_GOODS_CATES_REQUEST](state) {
        state.cateLoading = true;
    },
    [GET_SELF_GOODS_CATES_SUCCESS](state, res) {
        state.cateLoading = false;
        const { level } = res;
        state[`cateL${level || 1 || 4}`] = res.list;
    },
    [GET_SELF_GOODS_CATES_FAILURE](state) {
        state.cateLoading = false;
    },
    [UPDATE_WAIT_DATA](state, res) {
        state.waitData = res;
    },
    [UPDATE_SELF_GOODS_LIST](state, res) {
        state.listData = res;
    },
    [GET_SELF_GOODS_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.listData = [];
    },
    [CLEAR_SELF_GOODS_CATES](state, level) {
        if (level === 2) {
            // 一级不用清空
            state.cateL2 = [];
            state.cate2_id = '';
            state.cateL3 = [];
            state.cate3_id = '';
        } else if (level === 3) {
            state.cateL3 = [];
            state.cate3_id = '';
        }
    },
    // 更新请求参数
    [UPDATE_SELF_GOODS_LIST_PARAMS](state, params) {
        const { page } = params;
        if (page) {
            state.reqParams.page = page; // 分页要进行请求
        }
        state[Object.keys(params)[0]] = params[Object.keys(params)[0]];
    },
    [RESET_SELF_GOODS_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            inventoryStatus: 1,
            page: 1,
            pagesize: 20,
            goodsName: '',
            goodsBrand: '',
            isLoss: 1,
            cate1_id: '',
            cate2_id: '',
            cate3_id: '',
            goodsStatus: 1,
            barCode: '',
            tmp: 1,
            listData: [],
            pageCount: 1,
            reqParams: {},
            noData: false
        }));
    },
    [RESOLVE_SELF_GOODS_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getSelfGoodsList({ commit }) {
        commit(GET_SELF_GOODS_LIST_REQUEST);
        const res = await Vue.$ajax.get('getSelfGoodsList', state.reqParams);
        if (!res.errorType) {
            commit(GET_SELF_GOODS_LIST_SUCCESS, res);
        } else {
            commit(GET_SELF_GOODS_LIST_FAILURE);
        }
    },
    /**
     * 根据规格id删除商品
     */
    async delSelfGoods({ commit }, _sstoreSpecId) {
        MessageBox.confirm('确定删除已选中商品？', '确认订单', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose: false,
        }).then(async () => {
            console.log(_sstoreSpecId);
            const res = await Vue.$ajax.get('deleteSelfGoods', {sstore_spec_id: _sstoreSpecId});
            if (!res.errorType) {
                console.log(res);
                /* 删除操作后，改变页面的状态 */
                const newListData = state.listData.filter(item => item.sstore_spec_id !== _sstoreSpecId);
                commit(UPDATE_SELF_GOODS_LIST, newListData);
                MessageBox.alert('商品已成功删除', '提示', {
                    confirmButtonText: '我知道了'
                });
            } else {
                MessageBox.alert(res.errmsg || '未知错误', '提交失败！', {
                    confirmButtonText: '知道了'
                });
            }
        }).catch(() => { });
    },
    /**
     * 自营商品批量上架下架
     * @params {objVal} 0 批量下架 , 1批量上架
     */
    // eslint-disable-next-line no-unused-vars
    async selfGoodsBatchUpDown({ commit }, objVal) {
        const res = await Vue.$ajax.post('selfGoodsBatchUpDown', objVal);
        if (!res.errorType) {
            /* 下架上架操作后，改变页面的状态 */
            const goodsIds = objVal.goodsIds.split(',');
            const newListData = state.listData.map((item) => {
                const newItem = JSON.parse(JSON.stringify(item));
                if (goodsIds.indexOf(String(item.goodsId)) !== -1) {
                    let goodsStatus = objVal.type;
                    /* 限制库存为0或者禁售商品不可上架 */
                    if (item.inventory === 0 || item.isStopSell === 1) {
                        goodsStatus = 0;
                    }
                    newItem.goodsStatus = goodsStatus;
                }
                return newItem;
            });
            commit(UPDATE_SELF_GOODS_LIST, newListData);
            /* 提示成功 */
            Message({
                message: res.errmsg,
                tyep: 'success'
            });
        } else {
            MessageBox.alert(res.errmsg || '未知错误', '操作失败！', {
                confirmButtonText: '知道了'
            });
        }
    },
    resolveSelfGoodsListParams({ commit }) {
        let params = _.pick(state, ['goodsName', 'goodsBrand', 'inventoryStatus',
            'page', 'pagesize', 'barCode', 'tmp', 'cate1_id', 'cate2_id', 'cate3_id', 'isLoss', 'goodsStatus']);

        params = Object.assign({}, params, {});
        commit(RESOLVE_SELF_GOODS_LIST_PARAMS, params);
    },
    resetSelfGoodsList({ commit }) {
        commit(RESET_SELF_GOODS_LIST);
    },
    async getSelfGoodsCates({ commit }, query) {
        commit(GET_SELF_GOODS_CATES_REQUEST);
        const { level, cateId, isOrthers} = query;
        const list = await Vue.$ajax.get('getGoodsCate', {
            cateId,
            isOrthers
        });
        const res = {
            list,
            level
        };
        if (!list.errorType) {
            commit(GET_SELF_GOODS_CATES_SUCCESS, res);
        } else {
            commit(GET_SELF_GOODS_CATES_FAILURE);
        }
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/selfGoods.js